import api from './axiosConfig';

export type OffhoursProxyMode = 'ACTIVE' | 'SHADOW' | 'SUPPRESSED' | string;

export type OffhoursProxyItem = {
  provider?: string;
  providerSymbol?: string;
  underlyingCode?: string;
  displayName?: string;
  marketRole?: string;
  instrumentType?: string;
  markPx?: number | null;
  midPx?: number | null;
  oraclePx?: number | null;
  providerPrevChangePct?: number | null;
  windowAnchorChangePct?: number | null;
  fundingRate?: number | null;
  openInterest?: number | null;
  dayNotionalVolume?: number | null;
  observedAt?: string;
  ageSeconds?: number | null;
};

export type OffhoursProxyResponse = {
  mode?: OffhoursProxyMode;
  displayEligible?: boolean;
  label?: string;
  reason?: string;
  windowKey?: string;
  receivedAt?: string;
  staleSeconds?: number;
  disclaimer?: string;
  items?: OffhoursProxyItem[];
};

export async function getOffhoursMarketProxy(options?: {
  timeoutMs?: number;
  signal?: AbortSignal;
}): Promise<OffhoursProxyResponse> {
  const response = await api.get<OffhoursProxyResponse>('/live-summary/offhours-proxy', {
    timeout: options?.timeoutMs ?? 4_000,
    withCredentials: true,
    signal: options?.signal,
  });
  return response.data ?? {};
}
